import { Table, TableColumnConfig } from '@frontend/design-system';

type InsuranceReportTableProps<T extends object> = {
  tableInstanceId: string; // Unique identifier for the table instance
  tableData: T[]; // Generic type for the data array
  columns: TableColumnConfig<T>[]; // Array of column definitions
  onRowSelect?: (selectedRow: T) => void; // Optional callback function to handle row selection.
  defaultRowsPerPage?: number; // Optional prop to set default rows per page
  isPaginated?: boolean; // Optional prop to enable/disable pagination
  hasFilterColumns?: boolean; // Optional prop to enable/disable filter columns
};

export const InsuranceReportTable = <T extends object>({
  tableInstanceId,
  tableData,
  columns,
  defaultRowsPerPage = 10,
  isPaginated = true,
  hasFilterColumns = false,
}: InsuranceReportTableProps<T>) => {
  return (
    <Table
      tableInstanceId={tableInstanceId}
      isPaginated={isPaginated}
      hasResponsiveColWidths
      hasResizeColumns
      clientPaginationConfig={{
        defaultRowsPerPage,
      }}
      colConfig={columns}
      data={tableData}
      hasFilterColumns={hasFilterColumns}
    />
  );
};
